import { PRESET_FILTER_TYPES } from '../constants';
import {
  axiosRequestDELETE,
  axiosRequestGET,
  axiosRequestPOST,
  axiosRequestPUT,
} from './serviceConfig';

export const createUserFilterService = ({
  type = PRESET_FILTER_TYPES.ELEMENT_STATUS,
  filter,
}) => axiosRequestPOST(`/api/status/filters/${type}`, filter);

export const deleteUserFilterService = ({
  type = PRESET_FILTER_TYPES.ELEMENT_STATUS,
  id,
}) => axiosRequestDELETE(`/api/status/filters/${type}/${id}`);

export const getUserFiltersService = () =>
  axiosRequestGET('/api/status/filters');

export const updateUserFilterService = ({
  type = PRESET_FILTER_TYPES.ELEMENT_STATUS,
  id,
  filter,
}) => axiosRequestPUT(`/api/status/filters/${type}/${id}`, filter);
